import axios from "axios";

export const state = {
    closedloans: [],
};

export const getters = {
    closedloans: state => state.closedloans,
};

export const mutations = {
    setClosedLoans(state, newValue) {
        state.closedloans = newValue
    },
};

export const actions = {
    async fetchClosedLoans({ commit, rootState }) {
        const fyear = rootState.financialyears.currentFinancialYear;
        await axios.get(`/loans/closed/${fyear}`).then(res => {
            commit('setClosedLoans', res.data.closed_loans)
        })
    }
};
